import React, { useState, useReducer, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import "./index.scss";

import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/react-perfect-scrollbar/dist/css/styles.css";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { SizeMe } from "react-sizeme";
import ReactGA from "react-ga";
import { isMobile, isTablet } from "react-device-detect";
import i18n from "i18next";

import "./api/i18n/i18n";
import { ReplayerMode, SearchType } from "./api/ReplayVariables";
import { languages } from "./api/ReplayVariables";
import XeesterUser from "./api/user/User";
import { UserContext } from "./api/user/userContext";
import { SidebarContext } from "./api/sidebar/SidebarContext";
import { LoadingContext } from "./api/loading/LoadingContext";
import SidebarReducer from "./api/sidebar/SidebarReducer";
import LoadingReducer from "./api/loading/LoadingReducer";
import userReducer from "./api/user/userReducer";

import Replayer from "./replayer/Replayer";
import ChanelApp from "./webapp/chanel/ChanelApp";
import ReplayApp from "./webapp/replay-app/ReplayApp";
import Home from "./webapp/home/Home";
import TopBar from "./webapp/components/TopBar";
import LoginDialog from "./webapp/components/LoginDialog";
import Sidebar from "./webapp/components/Sidebar";
import Landing from "./webapp/landing/Landing";
import Search from "./webapp/search/Search";
import LoadingProgress from "./webapp/components/LoadingProgress";
import Settings from "./webapp/settings/Settings";

import XeesterApp from "./app/XeesterApp";

ReactGA.initialize("UA-26731168-1");

if (!Object.entries)
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array

    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
  };
window.setLng = (lng) => {
  if (languages.includes(lng)) {
    localStorage.setItem("lng", lng);
    i18n.changeLanguage(lng);
  }
};

window.setSoftwareMode = (test) => {
  var body = document.getElementById("root");
  if (!body.classList.contains("software-mode")) {
    body.classList.add("software-mode");
  }
};

window.serverUrl = window.location.href.indexOf(":7743")!=-1 ? "https://joomla4.xeester.com" :"";

/*
let translations = {
  fr: i18n.getResourceBundle("fr"),
  en: i18n.getResourceBundle("en"),
  it: i18n.getResourceBundle("it"),
  pt: i18n.getResourceBundle("pt")
};
console.info("json", JSON.stringify(translations));
*/

function App() {
  const [user, dispatchUser] = useReducer(userReducer, new XeesterUser());
  const [sidebar, dispatchSidebar] = useReducer(SidebarReducer, {
    open: false
  });
  const [loading, dispatchLoading] = useReducer(LoadingReducer, {
    progress: 0
  });
  const [showLogin, setShowLogin] = useState(false);

  const doSetShowLogin = useCallback(() => {
    setShowLogin(true);
    window.stop();
  }, []);
  const userLogged = (_user) => {
    dispatchUser({ type: "update", payload: _user });
  };

  function ReplayerComp({ mode }) {
    return (
      <SizeMe>
        {({ size }) => <Replayer size={size} mode={mode}></Replayer>}
      </SizeMe>
    );
  }

  useEffect(() => {
  let local = document.location.href.indexOf(":7743") != -1;
  let timer = null;
    if (!local)
    {
      console.log("user from index");
      fetch(window.serverUrl+"/social/user.php")
        .then((r) => r.json())
        .then((_user) => {
          dispatchUser({ type: "update", payload: XeesterUser.from(_user) });
        })
        .catch((err) => {
          console.error("fetch problem", err);
        });
    } else {
      timer = setTimeout(() => {
        dispatchUser({
          type: "update",
          payload: XeesterUser.from({
            id: 22253,
            name: "",
            username: "",
            email: "",
            registerDate: "2012-04-17 16:30:42",
            avatar: "users/avatar192.png",
            cb_description: "test\n\test\ntest",
            cb_notifications: "subscriptions|*|comments|*|replays",
            canvas: "",
            subscriptions: [],
            subscribers: 0,
            replays: 2
          })
        });
      }, 0);
    }

    const handleResize = () => {
      if (isMobile) {
        if (isTablet) {
          document.body.className = "mobile tablet";
        } else {
          document.body.className = "mobile";
        }
        if (
          window.matchMedia &&
          window.matchMedia("(orientation: landscape)").matches
        ) {
          document.body.className += " landscape";
        }
      }
    };
    const resizeListener = () => {
      handleResize();
    };
    handleResize();

    window.addEventListener("resize", resizeListener);
    //console.log("app effect");
    return () => {
      //console.log("app effect done");
      window.removeEventListener("resize", resizeListener);
      if (local) {
        clearTimeout(timer);
      }
    };
  }, [loading, dispatchLoading]);

  return (
    <>
      <UserContext.Provider value={{ user, dispatchUser }}>
        <SidebarContext.Provider value={{ sidebar, dispatchSidebar }}>
          <LoadingContext.Provider value={{ loading, dispatchLoading }}>
            <LoginDialog
              show={showLogin}
              handleClose={() => {
                setShowLogin(false);
              }}
              userLogged={userLogged}
            ></LoginDialog>
            <BrowserRouter basename={"/opencards/" + i18n.language}>
              <Switch>
                <Route path="/app/" />
                <Route path="/s/" />
                <Route path="/e/:id" />
                <Route path="/a/:id" />
                <Route path="/as/:id" />
                <Route path="/ea/:id" />
                <Route
                  path="/"
                  render={(props) => <LoadingProgress></LoadingProgress>}
                />
              </Switch>
              <Switch>
                <Route path="/app/" />
                <Route path="/s/" />
                <Route path="/e/:id" />
                <Route path="/a/:id" />
                <Route path="/as/:id" />
                <Route path="/ea/:id" />
                <Route
                  path="/"
                  render={(props) => (
                    <TopBar {...props} onShowLogin={doSetShowLogin}></TopBar>
                  )}
                />
              </Switch>
              <div className="root-inner d-flex">
                <Switch>
                  <Route path="/app/" />
                  <Route path="/s/" />
                  <Route path="/e/:id" />
                  <Route path="/a/:id" />
                  <Route path="/as/:id" />
                  <Route path="/ea/:id" />
                  <Route
                    path="/"
                    render={(props) => (
                      <Sidebar collapsed={true} {...props}></Sidebar>
                    )}
                  />
                </Switch>
                <div className="root-inner d-flex flex-column">
                  <Switch>
                    <Route
                      path="/app/"
                      render={(props) => <XeesterApp {...props}></XeesterApp>}
                    />
                    <Route
                      path="/s/"
                      render={(props) => (
                        <ReplayerComp
                          {...props}
                          mode={ReplayerMode.SOFTWARE}
                        ></ReplayerComp>
                      )}
                    />
                    <Route
                      path="/e/:id"
                      render={(props) => (
                        <ReplayerComp
                          {...props}
                          mode={ReplayerMode.EMBEDDED}
                        ></ReplayerComp>
                      )}
                    />
                    <Route
                      path="/a/:id"
                      render={(props) => (
                        <ReplayerComp
                          {...props}
                          mode={ReplayerMode.APP}
                        ></ReplayerComp>
                      )}
                    />
                    <Route
                      path="/as/:id"
                      render={(props) => (
                        <ReplayerComp
                          {...props}
                          mode={ReplayerMode.APP_STANDALONE}
                        ></ReplayerComp>
                      )}
                    />
                    <Route
                      path="/ea/:id"
                      render={(props) => (
                        <ReplayerComp
                          {...props}
                          mode={ReplayerMode.CODE}
                        ></ReplayerComp>
                      )}
                    />
                    <Route
                      path="/settings/infos"
                      exact
                      render={(props) => (
                        <Settings
                          {...props}
                          onLogin={doSetShowLogin}
                        ></Settings>
                      )}
                    />
                    <Route
                      path="/settings/display"
                      exact
                      render={(props) => (
                        <Settings
                          {...props}
                          onLogin={doSetShowLogin}
                        ></Settings>
                      )}
                    />
                    <Redirect path="/settings" to="/settings/infos" exact />
                    <Route
                      path="/history/viewed/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.viewed}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/history/commented/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.commented}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/history/voted/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.voted}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/history/vote1/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote1}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/history/vote2/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote2}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/history/vote3/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote3}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/history/vote4/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote4}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/history"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.all}
                          onShowLogin={doSetShowLogin}
                          startUrl="/history"
                          my={true}
                        ></Search>
                      )}
                    />

                    <Route
                      path="/w/:id"
                      render={(props) => (
                        <ReplayApp
                          {...props}
                          onShowLogin={doSetShowLogin}
                        ></ReplayApp>
                      )}
                    />
                    <Route
                      path="/c/:id/:tab/:category"
                      render={(props) => (
                        <ChanelApp
                          {...props}
                          onShowLogin={doSetShowLogin}
                        ></ChanelApp>
                      )}
                    />
                    <Route
                      path="/c/:id/:tab"
                      render={(props) => (
                        <ChanelApp
                          {...props}
                          onShowLogin={doSetShowLogin}
                        ></ChanelApp>
                      )}
                    />
                    <Redirect path="/c/:id/" to="/c/:id/home" />
                    <Route
                      path="/replays/viewed/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.viewed}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/replays/commented/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.commented}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/replays/voted/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.voted}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/replays/vote1/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote1}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/replays/vote2/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote2}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/replays/vote3/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote3}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/replays/vote4/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.vote4}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/replays/"
                      exact
                      render={(props) => (
                        <Search
                          {...props}
                          category={SearchType.all}
                          onShowLogin={doSetShowLogin}
                        ></Search>
                      )}
                    />
                    <Route
                      path="/home"
                      exact
                      render={(props) => (
                        <Home {...props} onShowLogin={doSetShowLogin}></Home>
                      )}
                    />
                    <Route
                      path="/"
                      exact
                      render={(props) => (
                        <Landing
                          {...props}
                          onShowLogin={doSetShowLogin}
                        ></Landing>
                      )}
                    />
                    <Redirect path="/" to="/" />
                  </Switch>
                </div>
              </div>
            </BrowserRouter>
          </LoadingContext.Provider>
        </SidebarContext.Provider>
      </UserContext.Provider>
    </>
  );
}

ReactDOM.render(<App></App>, document.getElementById("root"));

serviceWorker.unregister();
